import FlashServiceComponent from './flash/flash.component';
import FlashService from './flash.service';

angular
  .module( 'ais.flash-service', [] )
  .component( 'flashService', FlashServiceComponent )
  .service( 'FlashService', FlashService );